import React from 'react';
import { BetaReadiness } from '../components/BetaReadiness';
import { usePageTitle } from '../hooks/usePageTitle';

export function BetaPage() {
  usePageTitle('Beta Readiness');
  return (
    <div className="page-container">
      <BetaReadiness />
    </div>
  );
}
